import $ from 'jquery'
import { load } from '../utils/ajax'

export default class Paginator {
  constructor (options) {
    this.xhr = null
    this.options = $.extend(
      {
        $btn: null,
        page: 1,
        total: 1,
        url: window.location.href,
        params: () => {}
      },
      options || {}
    )
  }

  page (page) {
    if (typeof page !== 'undefined') {
      this.options.page = page
    }

    return this.options.page
  }

  total (total) {
    if (typeof total !== 'undefined') {
      this.options.total = total
    }

    return this.options.total
  }

  next (callback) {
    this.page(this.page() + 1)
    this.load(callback)
  }

  reset (callback) {
    this.page(1)
    this.load(callback)
  }

  toggle () {
    if (!this.options.$btn) {
      return
    }

    if (this.page() >= this.total()) {
      this.options.$btn.addClass('hidden')
    } else {
      this.options.$btn.removeClass('hidden')
    }
  }

  load (callback) {
    const params = $.extend(this.options.params(), { page: this.page() })

    if (this.xhr) {
      this.xhr.abort()
    }

    this.xhr = load(this.options.url, params, (response) => {
      if (typeof response.pagination !== 'undefined') {
        this.page(parseInt(response.pagination.page))
        this.total(parseInt(response.pagination.total_pages))
      }

      this.toggle()

      callback(response)
    })
  }
}
